var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59791 12.4003L1 13.048L1.59965 9.40209L9.67097 1.35475C9.78246 1.24234 9.91511 1.15312 10.0613 1.09223C10.2074 1.03135 10.3642 1 10.5225 1C10.6808 1 10.8376 1.03135 10.9837 1.09223C11.1298 1.15312 11.2625 1.24234 11.374 1.35475L12.6452 2.62602C12.7577 2.73751 12.8469 2.87015 12.9078 3.0163C12.9687 3.16244 13 3.3192 13 3.47752C13 3.63584 12.9687 3.7926 12.9078 3.93875C12.8469 4.08489 12.7577 4.21754 12.6452 4.32903L4.59791 12.4003Z",
    stroke: "#4E81F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.c70ae23769f879cc8d16afcd1235c950.svg";
export { ForwardRef as ReactComponent };